/*
         * @ngdoc function
         * @name ePay.Model:Session_ApplePaymentMethodModel
         * @description
         * Model
         */

export class Session_ApplePaymentMethodModel {
  displayName: string | null | undefined;
  network: string | null | undefined;
  type: string | null | undefined;

	constructor(
		displayName?: string, 
		network?: string, 
		type?: string
	) {
		this.displayName = displayName || null;
		this.network = network || null;
		this.type = type || null;
	}
}
